// Saved-view types — re-exported from the platform contract so consumers
// of `packages/ui-filters` don't need a second package import.
//
// The wire schemas live in `@eidollon/contracts/saved-screens` (Zod) so the
// API and the UI agree on the shape via one source of truth (CLAUDE.md
// Iron Rule #11). This file is thin sugar.

import type { savedScreens } from '@eidollon/contracts';
import {
  AoiAlertToggleResponse as AoiAlertToggleResponseSchema,
  SavedScreenListResponse as SavedScreenListResponseSchema,
} from '@eidollon/contracts/saved-screens';

export type SavedScreenSummary = savedScreens.SavedScreenSummary;
export type SavedScreenListResponse = savedScreens.SavedScreenListResponse;
export type AoiAlertToggleBody = savedScreens.AoiAlertToggleBody;
export type AoiAlertToggleResponse = savedScreens.AoiAlertToggleResponse;

export { SavedScreenListResponseSchema, AoiAlertToggleResponseSchema };

/** Parameters every SavedView consumer can configure. The defaults match the
 *  REST routes shipped in services/api. Override only if a future entity
 *  browser routes to a different surface. */
export interface SavedViewEndpoints {
  /** GET / POST list+create endpoint. Default `/v1/screens`. */
  listUrl?: string;
  createUrl?: string;
  /** DELETE endpoint; `:id` substituted at call time. Default `/v1/screens/:id`. */
  deleteUrl?: string;
  /** AOI-alert toggle endpoint. Default `/v1/saved-screens/:id/aoi-alert`. */
  aoiAlertUrl?: string;
}

export const DEFAULT_SAVED_VIEW_ENDPOINTS: Required<SavedViewEndpoints> = {
  listUrl: '/v1/screens',
  createUrl: '/v1/screens',
  deleteUrl: '/v1/screens/:id',
  aoiAlertUrl: '/v1/saved-screens/:id/aoi-alert',
};
